import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'valueOrFunction',
  pure: false,
  standalone: true
})
export class ValueOrFunctionPipe implements PipeTransform {

  transform(value: any | (() => any)) {
    if (typeof value === 'function') {
      return value();
    } else {
      return value;
    }
  }
}
